module.exports = __webpack_public_path__ + "static/media/MT-Series-Roof-Top.2ba2f1d1.png";